import React from "react";
import {Navbar, Nav, Container} from "react-bootstrap";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {login} from "./action";
import LoginForm from "./forms/LoginForm";

class LoginPage extends React.Component{
    
    submit = (data) => this.props.login(data).then(msg =>  window.location.reload());

    render(){

        return(

            <div>
                <Navbar expand="lg" variant="dark" className="bg-na fixed-top">
                    <Container>
                      <Link to="/"><Navbar.Brand className="nav-b">Back To Home</Navbar.Brand></Link>
                      <Nav className="ml-auto">
                          <Link className="nav-la" to="/signin">Sign In</Link>
                          <Link to="/register" className="hdf nav-l">Register</Link>
                      </Nav>
                    </Container>
                 </Navbar>

                 <div className="LoginMain" >
                    <LoginForm submit={this.submit}/>
                </div>


            </div>
        );
    };
};

export default connect(null, {login})(LoginPage);